import { useMutation, useQueries, useQuery } from "@tanstack/react-query";
import { axiosInstanceAuth } from "./client";
import { BaseResponse, ErrorResponse, IAOptionEvent, ICreateSetting, IDataSetting, IMastEnvs } from "interfaces";
import { AxiosError } from "axios";
import React from "react";

const getSettingShow = async () => {
	const res = await axiosInstanceAuth.get("/admin/statuses/bulk_show");
	return res as BaseResponse<IDataSetting>;
}
const getListEventsIndividual = async () => {
	const res = await axiosInstanceAuth.get("/admin/events/individual");
	return res as BaseResponse<IAOptionEvent[]>;
}
const getListEventsEveryone = async () => {
	const res = await axiosInstanceAuth.get("/admin/events/everyone");
	return res as BaseResponse<IAOptionEvent[]>;
}

export const useAdminGetSettingShow = () => {
  return useQueries({
    queries: [
      { queryKey: ['ADMIN_GET_SETTING_SHOW'], queryFn: getSettingShow },
      { queryKey: ['ADMIN_GET_LIST_EVENTS_INDIVIDUAL'], queryFn: getListEventsIndividual },
      { queryKey: ['ADMIN_GET_LIST_EVENTS_EVERYONE'], queryFn: getListEventsEveryone },
    ],
  });
};

export const useAdminUpdateSettingShow = (
	onOk?: (res: BaseResponse) => void,
	onErr?: (err: AxiosError<ErrorResponse>) => void
) => {
	return useMutation({
		mutationKey: ["ADMIN_UPDATE_SETTING_SHOW"],
		mutationFn: ( data : ICreateSetting) =>
			axiosInstanceAuth.patch("/admin/statuses/bulk_update", { data }),
		onSuccess: (res) => {
			onOk && onOk(res as BaseResponse);
		},
		onError: (err) => {
			onErr && onErr(err as AxiosError<ErrorResponse>);
		},
	});
};

export const 	useAdminGetEventDisplaySec = () => {
	const query =  useQuery({
		queryKey: ["ADMIN_GET_EVENT_DISPLAY_SEC"],
		queryFn: async () => {
			const res = await axiosInstanceAuth.get("/admin/mast_envs/show_by_key?key=EVENT_DISPLAY_RELOAD_SEC");
			return res as BaseResponse<IMastEnvs>;
		},
		retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 3000),
	});
	  const sec = React.useMemo<number>(() => {
    const raw = query.data?.data?.value;
    const parsed = raw != null ? Number(raw) : NaN;

    if (!isNaN(parsed)) return parsed;

    if (query.isError) return 10;

    return 10;
  }, [query.data, query.isError]);

  return { ...query, sec };
};

export const useAdminUpdateReloadSec = (
	onOk?: (res: BaseResponse) => void,
	onErr?: (err: AxiosError<ErrorResponse>) => void
) => {
	return useMutation({
		mutationKey: ["ADMIN_UPDATE_RELOAD_SEC"],
		mutationFn: ( data : { value: number }) =>
			axiosInstanceAuth.put("/admin/mast_envs/update_by_key?key=EVENT_DISPLAY_RELOAD_SEC", data ),
		onSuccess: (res) => {
			onOk && onOk(res as BaseResponse);
		},
		onError: (err) => {
			onErr && onErr(err as AxiosError<ErrorResponse>);
		},
	});
};